import * as types from '../actionTypes'
import { colorsService } from '../../_services'

export function getColors() {
    return dispatch => {
        return colorsService
            .getColors()
            .then(payload => {
                dispatch(success(payload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.FETCH_COLORS, payload: payload }
    }
    function failure(error) {
        return { type: types.FETCH_COLORS_FAILURE, error }
    }
}

export function updateColors(data) {
    return function(dispatch) {
        return colorsService
            .updateColors(data)
            .then(payload => {
                dispatch(success(payload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.UPDATE_COLORS, payload: payload }
    }
    function failure(error) {
        return { type: types.UPDATE_COLORS_FAILURE, error }
    }
}

export function addColors(data) {
    return function(dispatch) {
        return colorsService
            .addColors(data)
            .then(payload => {
                dispatch(success(payload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.UPDATE_COLORS, payload: payload }
    }
    function failure(error) {
        return { type: types.UPDATE_COLORS_FAILURE, error }
    }
}

export function removeColorsById(id) {
    return function(dispatch) {
        return colorsService
            .removeColorsById(id)
            .then(payload => {
                dispatch(success(payload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.REMOVE_COLOR, payload: payload }
    }
    function failure(error) {
        return { type: types.REMOVE_COLOR_FAILURE, error }
    }
}

export function removeColors(data) {
    return function(dispatch) {
        return colorsService
            .removeColors(data)
            .then(payload => {
                dispatch(success(payload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.REMOVE_COLORS, payload: payload }
    }
    function failure(error) {
        return { type: types.REMOVE_COLORS_FAILURE, error }
    }
}
